var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMapMarker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_107",
    "data-name": "Component 107",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 45,
    viewBox: "0 0 40 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient2",
    x2: 1,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcbc00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f2d301"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3635",
    "data-name": "Group 3635",
    transform: "translate(-116 -322)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3705",
    "data-name": "Path 3705",
    d: "M0,15,20,5,40,15V40L20,50,0,40Z",
    transform: "translate(116 317)",
    fill: "#253137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3706",
    "data-name": "Path 3706",
    d: "M0,14,18,5l18,9L18,23Z",
    transform: "translate(118 342)",
    fill: "url(#linear-gradient2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Kerb_White",
    "data-name": "Kerb White",
    transform: "translate(108.814 313.284)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5461",
    "data-name": "Path 5461",
    d: "M444.15,111.86h1.671v3.065a.164.164,0,0,0,.033-.025,2.05,2.05,0,0,1,1.277-.82,2.384,2.384,0,0,1,2.718,1.215,3.491,3.491,0,0,1,.395,1.249,5.089,5.089,0,0,1,.019,1.184,3.434,3.434,0,0,1-.571,1.669,2.349,2.349,0,0,1-1.434.982,3.031,3.031,0,0,1-1.724-.179,1.655,1.655,0,0,1-.755-.676c-.007-.013-.017-.024-.025-.036l-.012,0v.77h-1.59Q444.15,116.064,444.15,111.86Zm4.458,5.361c0-.038,0-.075,0-.113a2.764,2.764,0,0,0-.181-.938,1.483,1.483,0,0,0-.451-.636,1.267,1.267,0,0,0-.984-.248,1.191,1.191,0,0,0-.826.486,1.81,1.81,0,0,0-.29.6,3.158,3.158,0,0,0-.095,1.209,2.363,2.363,0,0,0,.262.9,1.286,1.286,0,0,0,1.725.561,1.353,1.353,0,0,0,.628-.695A2.726,2.726,0,0,0,448.608,117.221Z",
    transform: "translate(-411.399 -91.497)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5462",
    "data-name": "Path 5462",
    d: "M169.649,167.665h-4.4c.009.1.016.186.027.276a1.858,1.858,0,0,0,.17.6,1.112,1.112,0,0,0,.692.6,1.779,1.779,0,0,0,1.292-.061,1.257,1.257,0,0,0,.53-.423,1.1,1.1,0,0,0,.1-.186c.012-.027.022-.037.052-.037h1.4l.036,0c-.011.034-.021.067-.032.1a3.176,3.176,0,0,1-.664,1.139,2.465,2.465,0,0,1-1.122.682,3.769,3.769,0,0,1-1.291.131,3.23,3.23,0,0,1-1.158-.271,2.762,2.762,0,0,1-1.506-1.651,3.765,3.765,0,0,1-.21-1.358,3.387,3.387,0,0,1,.353-1.5,2.9,2.9,0,0,1,2.153-1.612,3.156,3.156,0,0,1,1.737.143,2.681,2.681,0,0,1,1.432,1.3,3.517,3.517,0,0,1,.4,1.4c.017.229.009.46.012.69A.314.314,0,0,1,169.649,167.665Zm-1.675-1.059a2.218,2.218,0,0,0-.273-.779,1.037,1.037,0,0,0-.653-.474,1.672,1.672,0,0,0-.462-.046,1.45,1.45,0,0,0-.7.181,1.27,1.27,0,0,0-.594.84c-.022.09-.033.182-.05.278Z",
    transform: "translate(-142.293 -141.531)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5463",
    "data-name": "Path 5463",
    d: "M194.846,21.128l-.425-.444-.816-.855q-.606-.635-1.212-1.27a.1.1,0,0,1-.024-.06q0-1,0-2c0-.009,0-.018,0-.038l2.477,2.6L199.2,16.46v.057q0,.984,0,1.968a.073.073,0,0,1-.042.073l-4.282,2.554Z",
    transform: "translate(-169.919)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5464",
    "data-name": "Path 5464",
    d: "M16.87,120.275H15.2V111.87h1.67Z",
    transform: "translate(0 -91.506)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5465",
    "data-name": "Path 5465",
    d: "M333.992,170.589H332.32V164.5h1.586v1.12l.013,0a.331.331,0,0,0,.025-.039,2.116,2.116,0,0,1,1.4-1.183,1.68,1.68,0,0,1,.723-.055c.17.027.17.027.17.2v1.4c-.139-.016-.274-.036-.41-.047a2.036,2.036,0,0,0-.828.087,1.339,1.339,0,0,0-.842.838,2.5,2.5,0,0,0-.158.888c0,.937,0,1.874,0,2.811Z",
    transform: "translate(-304.144 -141.82)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5466",
    "data-name": "Path 5466",
    d: "M58.77,170.893l.32-.306,1.052-1.007q.466-.446.932-.891a.1.1,0,0,1,.063-.029q.9,0,1.8,0l.033,0L60.633,170.9l2.333,3.917-.052,0H61.148a.063.063,0,0,1-.063-.033q-1.154-1.94-2.309-3.879A.074.074,0,0,0,58.77,170.893Z",
    transform: "translate(-41.787 -145.971)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5467",
    "data-name": "Path 5467",
    d: "M595.228,110.73a.615.615,0,0,1,.624.521.607.607,0,0,1-.5.7.629.629,0,0,1-.7-.328.609.609,0,0,1,.452-.878C595.15,110.736,595.189,110.734,595.228,110.73Zm-.006,1.1a.486.486,0,0,0,.013-.971.486.486,0,0,0-.013.971Z",
    transform: "translate(-555.689 -90.413)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5468",
    "data-name": "Path 5468",
    d: "M604.489,117.656l.18.3c-.047,0-.086,0-.124,0a.057.057,0,0,1-.035-.026c-.042-.07-.085-.14-.121-.213a.083.083,0,0,0-.113-.048v.285h-.136v-.683c.057,0,.115,0,.173,0a1.4,1.4,0,0,1,.185.009.172.172,0,0,1,.168.187c0,.1-.046.158-.159.185Zm-.212-.282v.183c.063,0,.122-.007.182-.012a.079.079,0,0,0,0-.157C604.4,117.38,604.341,117.378,604.277,117.374Z",
    transform: "translate(-564.842 -96.684)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarker);
export default __webpack_public_path__ + "static/media/map-marker.caf8635b283d2157b4736c90b7bf1756.svg";
export { ForwardRef as ReactComponent };